module.exports = __webpack_public_path__ + "static/media/background.27ca58ef.jpg";